import React from 'react';
import device from '../../../../services/mini/device';
import getPredefinedScriptIcon from '../../../../services/mini/getPredefinedScriptIcon';

class PredefinedScriptItem extends React.PureComponent {

    constructor(props, context) {
        super(props, context);
        this.state = {
            leaved: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isSelected && !this.props.isSelected && this.state.leaved) {
            this.setState({ leaved: false });
        }
    }

    onMouseLeave = () => {
        const { leaved } = this.state;
        const { isSelected } = this.props;
        
        if (isSelected && !leaved) {
            this.setState({ leaved: true });
        }
    }

    render() {
        const { leaved } = this.state;
        const { name, title, description, isSelected, toggleScriptTemplate } = this.props;

        return <div
            className={`predefined-script-item ${leaved && 'leaved'} ${isSelected && 'selected'} ${!device.isDesktop() && 'mobile'}`}
            onMouseLeave={this.onMouseLeave}
            onClick={() => toggleScriptTemplate(title)}>
            <div>
                <div className="predefined-script-item_icon">
                    <i className={`icon icon-${getPredefinedScriptIcon(name)}`} />
                </div>
                <div
                    className="predefined-script-item_name"
                    title={title}>
                    {title}
                </div>
            </div>

            <div className="predefined-script-item_hint">
                {description}
            </div>
        </div>;
    }
}

export default PredefinedScriptItem;
